import axios from '../../api/httpClient';
import { getApiHeaders } from '../../api/apiHeaders';
import {
    OPTION_ALERT_LIST_ATTEMPT,
    OPTION_ALERT_LIST_SUCCESS,
    OPTION_ALERT_LIST_FAILED,
    OPTION_ALERT_NEW_SUCCESS,
    OPTION_ALERT_NEW_FAILED,
    OPTION_ALERT_REMOVE_SUCCESS,
    OPTION_ALERT_REMOVE_FAILED,
} from '../types/optionAlertTypes';
import { config } from '../../config';

const url_api = config.api.web;

export const loadList = (data) => async (dispatch) => {
    dispatch({ type: OPTION_ALERT_LIST_ATTEMPT });
    try {
        const response = await axios.get(`${url_api}option_alert/`, {
            params: data.params,
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            dispatch({ type: OPTION_ALERT_LIST_SUCCESS, data: response.data.body });
            return { success: true };
        }
        dispatch({ type: OPTION_ALERT_LIST_FAILED, error: response.data.body });
        return { success: false };
    } catch (error) {
        dispatch({ type: OPTION_ALERT_LIST_FAILED, error: 'try_later' });
        return { success: false };
    }
};

export const newItem = (data) => async (dispatch) => {
    try {
        const response = await axios({
            method: 'post',
            url: `${url_api}option_alert/`,
            data: data.params,
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            dispatch({ type: OPTION_ALERT_NEW_SUCCESS, item: response.data.body });
            return { success: true, item: response.data.body };
        }
        dispatch({ type: OPTION_ALERT_NEW_FAILED, error: response.data.body });
        return { success: false, error: response.data.body };
    } catch (error) {
        const message = error.response?.data?.body || 'try_later';
        dispatch({ type: OPTION_ALERT_NEW_FAILED, error: message });
        return { success: false, error: message };
    }
};

export const removeItem = (data) => async (dispatch) => {
    try {
        const response = await axios({
            method: 'delete',
            url: `${url_api}option_alert/`,
            params: data.params,
            headers: getApiHeaders(),
        });
        if (response.status < 300 && response.data.status === 'Success') {
            dispatch({ type: OPTION_ALERT_REMOVE_SUCCESS, item: response.data.body });
            return { success: true };
        }
        dispatch({ type: OPTION_ALERT_REMOVE_FAILED, error: response.data.body });
        return { success: false };
    } catch (error) {
        dispatch({ type: OPTION_ALERT_REMOVE_FAILED, error: 'try_later' });
        return { success: false };
    }
};
